import React from 'react';

import Box from 'components/Box';
import { Image } from 'components/Image';

type Props = {
  isAmex?: boolean;
};

export function CreditCardBrandImage({ isAmex }: Props) {
  return (
    <Box
      component={Image}
      src={
        isAmex ? '/static/images/cc-amex.svg' : '/static/images/cc-other.svg'
      }
    />
  );
}
